import config from '../../../app/config'
import AxiosInstance from '../../axios/AxiosInstance'

export const getCurrentUserProfile = (signal) =>
  AxiosInstance.get(`${config().AUTH_SERVICE_BASE}/user/me/profile`, { signal })
